import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import { useExperiences } from "@hooks/useExperiences";
import Slider from "@components/V3/Slider";
import "@components/V3/Experiences/style.scss";

const ExperienceSlider = () => {
    const experiences = useExperiences() ?? [];

    const isMovieRewardsSite = useMemo(
        () =>
            typeof window !== "undefined" &&
            window.location.href.includes("movierewards"),
        []
    );

    const showExperiences = !isMovieRewardsSite && experiences.length > 0;

    if (!showExperiences) return null;

    return (
        <div className="movie-slider">
            <h2 className="experience-slider__title">Experiences</h2>
            <Slider
                className="experience-slider__list"
                wrapperClass="experience-slider__carousel"
                arrowClass="experience-slider__arrow"
            >
                {experiences.map(({ code, label, image, config }) => (
                    <div
                        className={`experience-slider__link-item experience-slider__link-item--${code}`}
                        key={code}
                    >
                        <Link
                            to={`/experiences/${label.toLowerCase()}`}
                            className="experience-slider__link"
                        >
                            <img
                                className="experience-slider__image"
                                src={`${config?.cdnUrl}asset/img/${image}`}
                                alt={`${label} Experience`}
                            />
                        </Link>
                        <div
                            className={`experience-slider__item-text experience-slider__item-text--${code}`}
                        >
                            {label}
                        </div>
                    </div>
                ))}
            </Slider>
        </div>
    );
};

export default ExperienceSlider;
